import axios from 'src/api/Api';
import {
    CANCEL_CALENDAR_SHARING_SUCCESS,
    CANCEL_CALENDAR_SHARING_FAILURE,
} from '../actions';
import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export default function* cancelCalendarSharing(action) {
    const url = `occ/v2/${localStorage.getItem('baseSiteId')}/orders/cancelcalendarsharing`;
    try {
        yield axios.post(url, action.payload).then((response) => response.data);
        yield put({
            type: CANCEL_CALENDAR_SHARING_SUCCESS,
            payload: {
                calendarSharingAddress: '',
                calendarSharingAddressGeneratedDate: '',
                isCalendarSharing: false,
            },
        });
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: CANCEL_CALENDAR_SHARING_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
